module.exports = __webpack_public_path__ + "img/map-background-1862383.jpg";